<!-- <div class="client-info">
  <h1>What Our Clients </h1>
  <h2>Say About Us</h2>
</div>
<div class="testimonial-outer"> -->
  <!-- <div class="testimonial-row"> -->
    <!-- <div class="testimonial-avatar">
      <img src="../../../assets/home/clients/nauri_bakkali.png" alt="Nauri Bakkali">
    </div>
    <div class="testimonial-card">
      <div class="testimonial-header">
        <span class="testimonial-name">Nauri Bakkali</span>
        <span class="testimonial-stars">★★★★★</span>
      </div>
      <div class="testimonial-position">
        Chief Executive Officer At Diligencia
      </div>
      <div class="testimonial-text">
              <p>I Wanted To Take A Moment To Thank You For The Services Your Team Has Provided.
        I Am Really Impressed By The Quality Of Services I Received From Kalpita Technologies (P) Ltd. You Were Right On Schedule,
        Charged Reasonable Prices, Were Professional And Courteous In Dealings, And Delivered Items Well Before Time.
        It Is Rare To Find A Service Provider With Such Professional Consistency - You Are A Valued Service Provider To Our Business
        And I Wouldn't Hesitate In Recommending You To Other Companies.</p>
      </div>
    </div> -->
  <!-- </div> -->
<!-- </div> -->





<div *ngIf="!hideHeading" class="client-info">
  <!-- <h1>What Our Clients </h1> -->
  <h2>What Our Clients Say About Us</h2>
</div>

<div class="testimonial-carousel-wrapper">
  <div class="testimonial-carousel-container">
    <div class="testimonial-carousel-slides" 
         [style.transform]="'translateX(' + transformValue + '%)'"
         (mouseenter)="pauseAutoSlide()"
         (mouseleave)="resumeAutoSlide()"
         (mousedown)="onMouseDown($event)"
         (mousemove)="onMouseMove($event)"
         (mouseup)="onMouseUp($event)"
         (mouseleave)="onMouseUp($event)"
         (touchstart)="onTouchStart($event)"
         (touchmove)="onTouchMove($event)"
         (touchend)="onTouchEnd($event)"
         [style.cursor]="isDragging ? 'grabbing' : 'grab'">
      
      <div class="testimonial-slide" *ngFor="let testimonial of testimonials">
        <div class="testimonial-outer">
<div class="testimonial-avatar">
            <!-- UPDATED: Wrapped image in anchor tag for LinkedIn link -->
            <a [href]="testimonial.linkedinUrl" target="_blank" rel="noopener noreferrer" 
               (mousedown)="$event.stopPropagation()" 
               (touchstart)="$event.stopPropagation()">
              <img [src]="testimonial.avatar" [alt]="testimonial.name">
            </a>
          </div>
          <div class="testimonial-card">
            <div class="testimonial-header">
              <span class="testimonial-name">{{ testimonial.name }}</span>
              <span class="testimonial-stars">★★★★★</span>
            </div>
            <div class="testimonial-position">
              {{ testimonial.position }}
            </div>
            <div class="testimonial-text">
              <p>{{ testimonial.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="carousel-dots">
      <span *ngFor="let testimonial of testimonials; let i = index" 
            [class.active]="i === currentSlide" 
            (click)="goToSlide(i)"></span>
    </div>
  </div>
</div>
